import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateNotificationSettingParams {
  userId: string; // site user id
  enabled: boolean;
}

export class UpdateNotificationSettingRequest extends Request<IUpdateNotificationSettingParams, IResult> {
  constructor(params: IUpdateNotificationSettingParams) {
    super('updateNotificationSetting', params);
  }
}
